<template>
  <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.250977 9.21484C0.250977 9.67188 0.602539 10.0674 1.16504 10.0674C1.4375 10.0674 1.68359 9.91797 1.90332 9.74219L2.90527 8.89844V17.0723C2.90527 18.373 3.6875 19.1465 5.03223 19.1465H16.9238C18.2598 19.1465 19.0508 18.373 19.0508 17.0723V8.85449L20.1055 9.74219C20.3164 9.91797 20.5625 10.0674 20.835 10.0674C21.3535 10.0674 21.749 9.74219 21.749 9.23242C21.749 8.93359 21.6348 8.69629 21.4062 8.50293L19.0508 6.5166V2.77246C19.0508 2.37695 18.7959 2.13086 18.4004 2.13086H17.1875C16.8008 2.13086 16.5371 2.37695 16.5371 2.77246V4.40723L12.2568 0.8125C11.4922 0.170898 10.5254 0.170898 9.76074 0.8125L0.602539 8.50293C0.365234 8.69629 0.250977 8.95996 0.250977 9.21484ZM13.5312 11.6406C13.5312 11.2275 13.2676 10.9639 12.8545 10.9639H9.16309C8.75 10.9639 8.47754 11.2275 8.47754 11.6406V17.3975H5.49805C4.95312 17.3975 4.6543 17.0898 4.6543 16.5361V7.43066L10.6221 2.4209C10.8682 2.20996 11.1494 2.20996 11.3955 2.4209L17.293 7.37793V16.5361C17.293 17.0898 16.9941 17.3975 16.4492 17.3975H13.5312V11.6406Z" :fill="color"/>
  </svg>
</template>
<script>
export default {
  name: 'MotoIcon',
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
